import { render, staticRenderFns } from "./OnControl.vue?vue&type=template&id=588dcbe8"
import script from "./OnControl.vue?vue&type=script&lang=js"
export * from "./OnControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports